// test1676
(1676 && 0);
